<template>
  <div>
    <form v-on:submit.prevent="checkForm" method="post">
      <div>

        <label for="name" class="block text-sm font-medium text-gray-700">Name</label>
        <div class="mt-1 relative rounded-md shadow-sm">
          <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <IdentificationIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
          </div>
          <input
              @input="v$.client.name.$touch"
              v-model="client.name"
              @focusin="isSearching = true"
              @blur="client.name.length > 0 ? null : isSearching = false"
              autocomplete="off"
              type="text"
              name="client"
              id="client"
              class="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
              placeholder="Coca Cola"
              @keyup="resetForm"
          />
        </div>

        <div v-if="isSearching && client.name.length > 0" class="dropdown-container">
          <ul>
              <li class="dropdown-container-item"  v-if="clients.length > 0" v-for="filteredClient in clients">
                <router-link :to="'/client/' + filteredClient.id">
                  <span>
                    {{ filteredClient.name }}
                  </span>
                </router-link>

              </li>
            <li class="dropdown-container-item" v-on:click="isConfirmingCreation = true" v-else>
              <div class="flex flex-row px-10 py-3">
                <div class="mr-10">
                  Whoops! That client doesn't exist yet....
                </div>
                <div class="flex flex-row align-middle">
                  <div class="mr-4">
                    <PlusCircleIcon class="w-10 h-10 mr-2 flex text-brand-primary" />
                  </div>
                  <div class="align-middle ">
                    Click here to create client '{{ client.name }}'
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>

<!--        <div-->
<!--            v-if="v$.client.name.$dirty"-->
<!--            v-for="error in v$.client.name.$silentErrors"-->
<!--            :key="error.$uid"-->
<!--            class="error-msg mt-1 ml-5 text-red-500 font-bold">-->
<!--          <small>-->
<!--            {{ error.$message }}-->
<!--          </small>-->
<!--        </div>-->
      </div>
      <div class="mt-3">
<!--        <primary-button-->
<!--            :disabled="v$.$invalid"-->
<!--            type="submit"-->
<!--            text="Create Client"/>-->
      </div>
    </form>
    <general-modal
        :open="isConfirmingCreation"
        title="Create Client"
        :content="'Are you sure you want to create this client with the name: ' + client.name + '?'"
        action-button-text="Create"
        cancel-button-text="Never mind"
        v-on:modal:cancel="isConfirmingCreation = false"
        v-on:modal:perform="checkForm"
    />
  </div>
</template>

<script>
import PrimaryButton from "@/components/Functional/Buttons/PrimaryButton";
import { IdentificationIcon, PlusCircleIcon } from '@heroicons/vue/solid'
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import GeneralModal from "@/components/Functional/Modal/GeneralModal";

export default {
  name: "ClientsForm",
  components: {
    GeneralModal,
    PrimaryButton,
    IdentificationIcon,
    PlusCircleIcon
  },
  setup() {
    return {
      v$: useVuelidate()
    }
  },
  data() {
    return {
      client: {
        name: '',
      },
      isSearching: false,
      isConfirmingCreation: false,
      errors: []
    }
  },
  watch: {
    client: function (newValue, oldValue) {
      console.log(newValue)
    },
  },
  methods: {
    resetForm: function() {
      this.errors = [];
      this.$store.dispatch('filterClients', this.client.name)
    },
    checkForm: async function(e) {
      if(this.client.name) {
        try {
          await this.$store.dispatch('createClient', this.client)
          this.$store.dispatch('createAlert', {
            type: 'success',
            message: 'Client Successfully Created'
          })
        } catch (e) {
          this.$store.dispatch('createAlert', {
            type: 'danger',
            message: e
          })
        }

      }
      this.isConfirmingCreation = false
      this.client.name = ''
    }
  },
  computed: {
    clients() {
      return this.$store.getters.getFilteredClients
    }
  },
  validations: {
    client: {
      name: { required },
    }
  },
}
</script>

<style scoped>

</style>
